// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import DateRange from '../domain/DateRange';

type Props = {
  value: DateRange;
  t: any;
}

function DateRangeDisplay({ value, t }: Props) {
  return <div>{t('date.dateRange', { from: value.from, to: value.to })}</div>;
}

export default translate('common')(DateRangeDisplay);



// WEBPACK FOOTER //
// ./src/common/components/DateRangeDisplay.js